import "../App.css";
import React, { Suspense } from "react";
import "../new-app.css";
// import Header from "../component/header/index.jsx";
import Footer from "../component/footer/index.jsx";
import {
  // useParams,
  useLocation,
  // useSearchParams,
  useNavigate,
} from "react-router-dom";
// import { useAuthContext } from "../AuthContext";
import { useContext, useEffect, useState } from "react";
// import { SidebarContext } from "../component/Context/SidebarContext";
import { FetchGames } from "../GameServices/GameServices";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { GameDataContext } from "../component/Context/GameDataContext";
import Button from "../component/Button/Button";

function Home() {
  useEffect(() => {
    const classExists = document.querySelector(".addclass") !== null;
    if (!classExists) return;
    document.body.classList.add("homepageActive");
    return () => {
      document.body.classList.remove("homepageActive");
    };
  }, []);
  

  const [hover, setHover] = useState();
  const [glory, setGlory] = useState();
  const [loadMore, setLoadMore] = useState(false);
  const [gamesList, setGamesList] = useState([]);

  const navigate = useNavigate();
  // useEffect(() => {
  //   // window.scrollTo(0, 0);
  // }, []);

  const playGameHandler = (gameName) => {
    navigate(`/playgame/${gameName}`);
  };
  const search = useLocation().search;
  const referAddress = new URLSearchParams(search).get("referral");

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  localStorage.setItem("referAddress", referAddress);
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  useEffect(() => {
    fetchGames();
    const Interval = setInterval(() => {
      setGlory(randomIntFromInterval(0, 21));
    }, 2000);
    return () => {
      clearInterval(Interval);
    };
  }, []);
  const onHover = (param) => {
    setHover(param);
  };

  const fetchGames = async () => {
    let { data } = await FetchGames();
    setGamesList(data);
    console.log("games list", data);
  };
  return (
    <div className="homeMain homeBg addclass">
      <section className="home-sec-1" key={1}>
        <div className="container-1280 container-1600">
          <div className="row">
            <div className="col-lg-6 col-md-6  m-auto">
              <div className="banner-home-content">
                <img className="d-md-none d-lg-none mob-poly-letsplay" src={require("../Assets/img/poly-vec.png")} />
                <h2 className="white-color lg-txt">Let’s Play</h2>
                <h1 className="stylish-txt">& Earn </h1>
                <a className="hz-linear-button btn-gradient-home" onClick={() => navigate("/games")}>
                  <span className="animate-glory overflow-hidden animate-span"></span>
                  Explore More
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="sec-1-imgs sec-1-imgsHome">
                <img src={require("../Assets/img/new-mbl.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="textGradiant">
          <span>Creators</span>
        </div>
        {/* <div className='lines '>
          <img src={require("../Assets/img/home-bg.png")} alt='' />
          <img src={require("../Assets/img/home-coin1.png")} alt='' />
          <img src={require("../Assets/img/home-coin1.png")} alt='' />
        </div> */}
      </section>
      <section className="home-sec-2" key={2}>
        <h2 className="gradient-txt">Our Top</h2>
        <h1 className="gradiant-heading mb-100">
          {" "}
          <img src={require("../Assets/img/Game-1.png")} alt="" />
        </h1>
        <div className="purple-layer">
          <span>
            {/* {" "}
            <img src={require("../Assets/img/Home-mobile.png")} /> */}
          </span>
        </div>

        <section className="games-section games-section-home">
          <img src={require("../Assets/img/bg_sec2_img.png")} className="gamesec-home-bg1" alt="" />
          <div className="container-1280 games-container hz-game-contain">
            <div className="row games-row">
              <div className="col-12">
                <div className="images-row">
                  <div className="row">
                    <div className="col-5 p-xs-0">
                      <div className={`game-big-box ${glory === 1 ? "animate-glory" : ""}`}>
                        <img
                          // src={
                          //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                          // }
                          src={gamesList[0]?.thumbnail}
                          alt="Game"
                          onClick={() => {
                            playGameHandler(gamesList[0]?.name);
                          }}
                          onMouseEnter={() => onHover(1)}
                          onMouseLeave={() => setHover("")}
                        />
                        <span>{gamesList[0]?.gameBuild}</span>
                      </div>
                    </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          <div className="game-md-box">
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[1]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[1]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[1]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className={`game-md-box ${glory === 3 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[2]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[2]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[2]?.gameBuild}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <div className={`game-sm-box ${glory === 4 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[3]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[3]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[3]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-4 p-xs-0">
                          <div className={`game-sm-box ${glory === 5 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[4]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[4]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[4]?.gameBuild}</span>
                          </div>
                        </div>

                        <div className="col-4">
                          <div className={`game-sm-box ${glory === 6 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[5]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[5]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[5]?.gameBuild}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-8 ">
                      <div className="row">
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 7 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[6]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[6]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[6]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 8 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[7]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[7]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[7]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 9 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[8]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[8]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[8]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 10 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[9]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[9]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[9]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 11 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[10]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[10]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[10]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 12 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[11]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[11]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[11]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 13 ? "animate-glory" : ""}`}>
                            <img
                              // src={
                              //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                              // }
                              src={gamesList[12]?.thumbnail}
                              alt="Game"
                              onClick={() => {
                                playGameHandler(gamesList[12]?.name);
                              }}
                              onMouseEnter={() => onHover(1)}
                              onMouseLeave={() => setHover("")}
                            />
                            <span>{gamesList[12]?.gameBuild}</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className={`game-xs-box ${glory === 14 ? "animate-glory" : ""}`}>
                            <img src={require("../../src/Assets/img/game16.png")} alt="" />
                            <span>Ludo Club</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className={`game-medbox-2 ${glory === 15 ? "animate-glory" : ""}`}>
                        <img
                          src={require("../../src/Assets/img/game12.png")}
                          alt="Game"
                          onClick={() => {
                            playGameHandler("Pacman");
                          }}
                        />
                        <span>PAC-MAN</span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <div className={`game-medbox-2 ${glory === 16 ? "animate-glory" : ""}`}>
                        <img
                          src={require("../../src/Assets/img/flappy.png")}
                          alt="Game"
                          onClick={() => {
                            playGameHandler("flappybirds");
                          }}
                        />
                        <span>Flappy Birds</span>
                      </div>
                    </div>
                    <div className="col-4 p-xs-0">
                      <div className="row">
                        <div className="col-6">
                          <div className={`game-xs-box ${glory === 17 ? "animate-glory" : ""}`}>
                            <img
                              src={require("../../src/Assets/img/game13.png")}
                              alt="Game"
                              onClick={() => {
                                playGameHandler("DinoJump");
                              }}
                            />
                            <span>Dino Run</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className={`game-xs-box ${glory === 18 ? "animate-glory" : ""}`}>
                            <img
                              src={require("../../src/Assets/img/game5.png")}
                              alt="Game"
                              onClick={() => {
                                playGameHandler("Hillclimbracing");
                              }}
                            />
                            <span>Hill Climb</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className={`game-xs-box ${glory === 19 ? "animate-glory" : ""}`}>
                            <img
                              src={require("../../src/Assets/img/game6.png")}
                              alt="Game"
                              onClick={() => {
                                playGameHandler("PaperToss");
                              }}
                            />
                            <span>Paper Toss</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                            <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                            <span>Sniper 3D</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className={`game-medbox-2 ${glory === 21 ? "animate-glory" : ""}`}>
                        <img
                          src={require("../../src/Assets/img/jumpball.png")}
                          alt="Game"
                          onClick={() => {
                            playGameHandler("HelixJump");
                          }}
                        />
                        <span>Helix Jump</span>
                      </div>
                    </div>

                    {loadMore ? (
                      <div className="unpublished">
                        <div className="col-12 p-xs-0">
                          <div className="row">
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 19 ? "animate-glory" : ""}`}>
                                <img
                                  src={require("../../src/Assets/img/game6.png")}
                                  alt="Game"
                                  onClick={() => {
                                    playGameHandler("PaperToss");
                                  }}
                                />
                                <span>Paper Toss</span>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                                <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                                <span>Sniper 3D</span>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                                <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                                <span>Sniper 3D</span>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                                <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                                <span>Sniper 3D</span>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                                <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                                <span>Sniper 3D</span>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className={`game-xs-box ${glory === 20 ? "animate-glory" : ""}`}>
                                <img src={require("../../src/Assets/img/gun.png")} alt="Game" />
                                <span>Sniper 3D</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* <div className="col-one-item" key={1}>
                   
                    
                  </div>
                  <div className="col-two-item col-two-item-height" key={2}>
                    
                    
                  </div>
                  <div className="col-one-item" key={3}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={4}>
                    
                   
                  </div>

                  <div className="col-two-item col-two-item-height" key={5}>
                    
                    
                  </div>

                  <div className="col-one-item " key={6}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={7}>
                    
                    
                  </div>

                  <div className="col-one-item" key={8}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={9}>
                    
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={10}>
                   
                    
                  </div>

                  <div className="col-one-item long-item" key={11}>
                    
                  </div> */}
                </div>
              </div>
            </div>
            <Button className="animate-glory" value="Load more..." onClick={() => setLoadMore(!loadMore)} />
          </div>
        </section>
      </section>

      <section className="home-sec-3 bg-image-lines-right-nft" key={3}>
        <div className="container-1280 max-w-1468">
          <div className="row">
            <div className="col-lg-6 col-md-6  m-auto p-0">
              <div className="our-nft">
                <h2 className="gradient-txt">
                  Our <span> NFTs</span>
                </h2>
                <ul>
                  <li>
                    Lorem Ipsum is simply dummy text of the printing <br></br> and typesetting industry.
                  </li>
                  <li>
                    Lorem Ipsum is simply dummy text of the printing <br></br> and typesetting industry.
                  </li>
                  <li>
                    Lorem Ipsum is simply dummy text of the printing <br></br> and typesetting industry.
                  </li>
                  <li>
                    Lorem Ipsum is simply dummy text of the printing <br></br> and typesetting industry.
                  </li>
                </ul>
                <a className="explore-btn explore-ban d-none-mobile" onClick={() => navigate("/NftJourney")}>
                  Explore More
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 our-nft-img-main p-0">
              <div className="our-nft-img">
                <img src={require("../Assets/img/game-pass.gif")} alt="" />
              </div>
              <div className="text-center mt-">
                <a
                  className="explore-btn explore-ban d-sm-inline-block m-auto d-md-none d-lg-none"
                  onClick={() => console.log("Explore More")}
                >
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='home-sec-line'>
          <img src={require("../../src/Assets/img/towLines.png")} alt='' />
        </div> */}
      </section>

      <section className="home-sec-4" key={4}>
        <div className="sec-4-title">
          <h2 className="gradient-txt">Statistics</h2>
          <span className="gradient-bar">
            <img className="img-fluid" src={require("../Assets/img/gradian-line.png")} alt="" />
          </span>
        </div>

        <div className="position-relative after-before-images">
          <div className="container-1280 max-w-1468">
            <div className="col-settings justify-content-center row">
              <div className="col-lg-4">
                <div className="statistic state-1">
                  <img className="img-fluid" src={require("../Assets/img/diamond5.png")} alt="" />
                  <h2>10,000+</h2>
                  <p>Influencers Activations</p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="statistic state-2">
                  <div>
                    <h2>340+</h2>
                    <p>Games Promoted</p>
                    <img className="img-fluid" src={require("../Assets/img/gaming.png")} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 ">
                <div className="statistic state-3">
                  <img className="img-fluid" src={require("../Assets/img/heart1.png")} alt="" />
                  <h2>500+</h2>
                  <p>Trusted Brands</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-sec-5 eco-sec our-eco-sec" key={5}>
        <div className="container-1280">
          <div className="row eco-system">
            <div className="col-lg-6 col-md-6 m-auto">
              <div className="eco-head">
                <h1>
                  Our <br />
                  <span>Ecosystem</span>
                </h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                  dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen
                  book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially
                  unchanged.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 m-auto eco-images">
              <div className="eco-box">
                <h3>Game Frontend</h3>
                <img src={require(".././Assets/img/unity.png")} alt="" />
              </div>
              <div className="eco-box">
                <h3>For Mobile Gaming</h3>
                <img src={require(".././Assets/img/game-mbl.png")} alt="" />
              </div>
              <div className="eco-box">
                <h3>Blockchain</h3>
                <img src={require(".././Assets/img/polyyy.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="image-wrap-center" key={6}>
        <div className="ecosystemBg">
          <section className="fullWidth-sec d-none d-md-block">
            <div className=" eco-back">
              <h2 className="m-0">Eco System</h2>
            </div>
          </section>
          <section className="home-sec-6 partners">
            <div>
              <div className="row">
                <div className="col-lg-12">
                  <h2>Our Partners</h2>
                </div>
                <div className="partner-logo">
                  <Carousel
                    autoPlay={true}
                    autoPlaySpeed={2000}
                    responsive={responsive}
                    arrows={false}
                    infinite={true}
                    focusOnSelect={true}
                    centerMode={true}
                    rtl={false}
                    slidesToSlide={1}
                  >
                    <div>
                      <img src={require(".././Assets/img/market-watch.png")} alt="" />
                    </div>
                    <div>
                      {" "}
                      <img src={require(".././Assets/img/market-watch.png")} alt="" />
                    </div>

                    <div>
                      <img src={require(".././Assets/img/NewsBTC.png")} alt="" />
                    </div>
                    <div>
                      <img src={require(".././Assets/img/market-watch.png")} alt="" />
                    </div>
                    <div>
                      <img src={require(".././Assets/img/market-watch.png")} alt="" />
                    </div>
                  </Carousel>
                  ;
                  {/* <Carousel
                    responsive={responsive}
                    // useKeyboardArrows = {true}
                  >
                  
                  </Carousel> */}
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="explore-games play-earn play-earn-mob">
          <div className="container-1280">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <h2>
                  Play <span>To Earn</span>
                </h2>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                  dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen
                  book. It has survived not only five centuries,
                </p>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={require(".././Assets/img/gaming-consolee.png")} alt="icon" />
              </div>
            </div>
          </div>
        </section>
        <section className="explore-games play-earn play-earn-mob ptb-0-mb">
          <div className="container-1280">
            <div className="row">
              <div className="col-lg-6 col-md-6 crpto">
                <img src={require(".././Assets/img/poly-banner.png")} alt="icon" />
              </div>
              <div className="col-lg-5 col-md-6 ml-auto ms-auto">
                <h2>
                  Got <span>Crypto?</span>
                </h2>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                  dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen
                  book. It has survived not only five centuries,
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="home-sec-6 logos-settings" key={7}>
        <div className="">
          <div className="row">
            <div className="col-lg-12">
              <h2>In The News</h2>
            </div>
            <div className="partner-logo">
              <Carousel
                autoPlay={true}
                autoPlaySpeed={2000}
                responsive={responsive}
                arrows={false}
                infinite={true}
                focusOnSelect={true}
                centerMode={true}
                rtl={false}
                slidesToSlide={1}
              >
                <div>
                  <img src={require(".././Assets/img/market-watch.png")} alt="" />
                </div>
                <div>
                  {" "}
                  <img src={require(".././Assets/img/market-watch.png")} alt="" />
                </div>

                <div>
                  <img src={require(".././Assets/img/NewsBTC.png")} alt="" />
                </div>
                <div>
                  <img src={require(".././Assets/img/market-watch.png")} alt="" />
                </div>
                <div>
                  <img src={require(".././Assets/img/market-watch.png")} alt="" />
                </div>
              </Carousel>
              ;
              {/* <Carousel
                  responsive={responsive}
                  // useKeyboardArrows = {true}
                >
                
                </Carousel> */}
            </div>
          </div>
        </div>
      </section>

      <section className="home-sec-5 mt-5 last-section-changes" key={8}>
        <div className="container-1280">
          <div className="row eco-system">
            <div className="col-lg-6 col-md-6 m-auto">
              <div className="eco-head">
                <h1>
                  <span>Intergrate</span>
                  <br />
                  With Us
                </h1>
                <p className="d-none d-md-block">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                  dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen
                  book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially
                  unchanged.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 m-auto eco-images">
              <div className="eco-box eco-box-inner">
                <img src={require(".././Assets/img/control-back.png")} alt="" />
              </div>
              <div className="eco-box eco-box-inner">
                <img src={require(".././Assets/img/vend-mach.png")} alt="" />
              </div>
              <div className="eco-box eco-box-inner">
                <img src={require(".././Assets/img/block-chain.png")} alt="" />
              </div>
            </div>
            <div>
              <p className="text-left d-md-none pb-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen
                book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially
                unchanged.
              </p>
              <div className="text-left">
                <a
                  className="explore-btn explore-ban d-sm-inline-block m-auto d-md-none d-lg-none  mt-3"
                  onClick={() => console.log("Explore More")}
                >
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="ptb-100 ptb-100-home-contact" key={9}>
        <section className="contact-sec contact-sec-home">
          <div className="container-1280">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6">
                <div className="knowl-txt">
                  <h2 className="gradient-txt f-42">Knowledge Is Power</h2>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="get-started">
                  <input type="text" id="fname" name="fname" placeholder="John" />
                  <input type="submit" value="Submit" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default React.memo(Home);
